import { actionCreators } from './LogsState';

export const fetchLogsFolderInfo = async (dispatch: any) => {
  return dispatch(actionCreators.fetchLogsFolderInfo());
};

export const fetchUploadLogsDirectories = async (dispatch: any) => {
  return dispatch(actionCreators.fetchUploadLogsDirectories());
};
